import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Client } from "../model/client";

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  private baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  public getClients(): Observable<any> {
    console.log("Get all members data..");
    const  headers = new  HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<Client[]>(this.baseUrl.concat("/clients"), {headers: headers});
  }
}
